export default "__VITE_ASSET__BFec6SMi__"